// extracted by mini-css-extract-plugin
export default {"resultChanged":"GlobalClasses_resultChanged__+hs+y","handleBkg":"GlobalClasses_handleBkg__+Icb6"};